import React, { useState } from 'react';
import './SocialShare.css';

function SocialShare({ dish, onShare }) {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const shareUrl = typeof window !== 'undefined' 
    ? `${window.location.origin}/dish/${dish.id}` 
    : '';
  
  const shareText = `Check out ${dish.name} on RatedBite! ${dish.restaurantName ? `From ${dish.restaurantName}` : ''}`;

  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
    if (onShare) onShare('twitter');
  };

  const shareToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
    if (onShare) onShare('facebook');
  };

  const shareToInstagram = () => {
    // Instagram doesn't support direct sharing via URL, so we'll copy a pre-formatted text
    const instagramText = `${shareText}\n\n#RatedBite #FoodRating #FoodQuality`;
    navigator.clipboard.writeText(instagramText).then(() => {
      alert('Text copied! Paste it in your Instagram post and tag us with #RatedBite');
      setShowShareMenu(false);
      if (onShare) onShare('instagram');
    });
  };

  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      alert('Link copied to clipboard!');
      setShowShareMenu(false);
      if (onShare) onShare('link');
    });
  };

  return (
    <div className="social-share-container">
      <button
        className="share-button"
        onClick={() => setShowShareMenu(!showShareMenu)}
        aria-label="Share dish"
      >
        <span className="share-icon">🔗</span>
        Share
      </button>

      {showShareMenu && (
        <div className="share-menu">
          <button onClick={shareToTwitter} className="share-option">
            <span className="social-icon">🐦</span>
            Twitter
          </button>
          <button onClick={shareToFacebook} className="share-option">
            <span className="social-icon">📘</span>
            Facebook
          </button>
          <button onClick={shareToInstagram} className="share-option">
            <span className="social-icon">📷</span>
            Instagram
          </button>
          <button onClick={copyLink} className="share-option">
            <span className="social-icon">🔗</span>
            Copy Link
          </button>
        </div>
      )}
    </div>
  );
}

export default SocialShare;

